<template>
  <div class="search-form flex-nowrap">
    <div
      class="search-form__search-btn"
      :class="{ active: mobileSearchForm }"
      @click="mobileSearchForm = !mobileSearchForm"
    >
      <icon name="search-icon" />
      <icon name="decline-close" />
    </div>
    <div
      class="search-form__body search-form__body--full-width-sm"
      :class="{ active: mobileSearchForm }"
    >
      <div class="search-form__field">
        <input
          v-model="search"
          type="text"
          placeholder="חיפוש"
          class="search-form__field-input"
        />
        <div class="search-form__field-icon">
          <icon name="search-icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchForm',
  props: {
    searchText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mobileSearchForm: false,
      search: this.searchText
    };
  },
  watch: {
    search(val) {
      this.$emit('input', val);
    }
  }
};
</script>
<style scoped>
@media (max-width: 767.98px) {
  .search-form__search-btn {
    z-index: 1;
  }
}
</style>
